/*
 *** Usage in FO: OK
 *** Usage in PO: OK
 *** Usage in BO: OK
 */

import PropTypes from 'prop-types';

import { AttachedFile } from '@hivebrite/design-system/AttachedFile';
import { Box } from '@hivebrite/design-system/Box';

const AttachedFiles = ({ attachedFiles, ...otherProps }) =>
  attachedFiles.map((file, i) => (
    <Box mt={i > 0 ? 3 : 0} key={file.id} minWidth={0} {...otherProps}>
      <AttachedFile
        file={{
          name: file.filename || file.fileName || file.file_name,
          url:
            file.downloadUrl ||
            file.download_url ||
            file.previewUrl ||
            file.preview_url ||
            file.fileUrl ||
            file.file_url,
        }}
        withLink
      />
    </Box>
  ));

AttachedFiles.propTypes = {
  attachedFiles: PropTypes.array.isRequired,
};

export default AttachedFiles;
